import { api } from "../App";
import { createNotification } from "../components/Notifications/Notifications";
import {
  GET_SUBJECTS_EXTRA_EDU_LIST
} from "./types";





// <----  ПРЕДМЕТЫ ДО ---->

export const getSubjectsExtraEdu = (status) => async (dispatch, getState) => {
  try {
    const urlParams = status.status !== "Идет" ? '' : new URLSearchParams(status).toString();
    const { data } = await api.get(`/xp_courses?${urlParams}`);
    dispatch({ type: GET_SUBJECTS_EXTRA_EDU_LIST, payload: data });
  } catch (error) {
    console.error('Error in directoryExtraEducation action:', error);
  }
};

// export const getTrackProfileCurr = (id) => async (dispatch, getState) => {
//   try {
//     const { data } = await api.get(`/track_profile/${id} `);
//     dispatch({ type: GET_TRACK_PROFILE_CURR, payload: data });
//   } catch (error) {
//     console.error('Error in directoryExtraEducation action:', error);
//   }
// };

export const updateSubjectsExtraEdu = (params) => async (dispatch, getState) => {
  try {
    await api.put(`/xp_courses/${params.xp_key}`, params);
    await dispatch(getSubjectsExtraEdu());
  } catch (error) {
    console.error('Error in directoryExtraEducation action:', error);
  }
}

export const createSubjectsExtraEdu = (data) => async (dispatch, getState) => {
  try {
    await api.post(`/xp_courses`, data);
    createNotification('success', 'Успешно');
    await dispatch(getSubjectsExtraEdu());
  } catch (error) {
    console.error('Error in directoryExtraEducation action:', error);
    createNotification('error', "Не удалось создать запись");
  }
};

export const deleteSubjectsExtraEdu = (id) => async (dispatch, getState) => {
  try {
    await api.delete(`/xp_courses/${id}`);
    createNotification('success', 'Успешно');
    await dispatch(getSubjectsExtraEdu());
  } catch (error) {
    console.error('Error in directoryExtraEducation action:', error);
    createNotification('error', error.message || 'Произошла ошибка');
  }
};
